import React, { Suspense } from "react";
import { PostulationForm } from "@rankmi/ats-app";

const PostulationFormApplicant = ({ token, tenantId, currentUser, organizationToken }) => {

  return (
    <Suspense fallback="">
      <PostulationForm
        token={token}
        tenantId={tenantId}
        currentUser={currentUser}
        organizationToken={organizationToken}
      />
    </Suspense>
  )
};

export default PostulationFormApplicant;
